import React, { useMemo } from 'react';
import { Card, CardContent } from '../../../../../components/ui/card';
import { Shield } from 'lucide-react';
import { DocumentGroups } from './DocumentGroups';
import { PipeSize, SpecificationDocument } from '../../../types/index';
import type { DashboardProject } from '../../../types/project';

interface FabricationSpecificationsProps {
  project: DashboardProject;
  groupedSpecifications: Record<string, SpecificationDocument[]>;
  pipeSizes: PipeSize[];
  handleDownload: (spec: SpecificationDocument) => void;
}

export const FabricationSpecifications: React.FC<FabricationSpecificationsProps> = ({
  project,
  groupedSpecifications,
  pipeSizes,
  handleDownload,
}) => {


  const getFabricationType = (title: string) => {
    return (
      <div className="space-y-6">
        <div className="flex items-center gap-2 text-purple-800">
          <Shield className="h-5 w-5" />
          <h3 className="text-lg font-medium">{title}</h3>
        </div>
        {Object.keys(groupedSpecifications).map((pipeId) => {
          const pipeIndex = parseInt(pipeId.split('-')[1]);
          const pipe = pipeSizes[pipeIndex];
          const specs = groupedSpecifications[pipeId];

          return (
            <Card key={pipeId} className="border-2 border-gray-200">
              <CardContent className="p-6">
                <div className="space-y-6">
                  {/* Pipe Header */}
                  <div className="flex items-center gap-2 pb-4 border-b border-gray-200">
                    <h4 className="text-lg font-semibold text-gray-800">
                      Pipe {pipeIndex + 1}
                    </h4>
                    <span className="text-sm text-gray-500">
                      ({pipe?.size}" × {pipe?.wallThickness}")
                    </span>
                    <span className="text-sm text-gray-500 ml-auto">
                      {specs.length} document{specs.length !== 1 ? 's' : ''}
                    </span>
                  </div>

                  {/* Document Groups */}
                  <DocumentGroups specs={specs} handleDownload={handleDownload} />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  }
  return (
    <div className="space-y-6">
      {project.projectTypes.fabrication && project.fabricationOptions?.buckleArrestor && 
        getFabricationType('Buckle Arrestor')
      }
      {project.projectTypes.fabrication && project.fabricationOptions?.pipeInPipe && 
        getFabricationType('Pipe in Pipe')
      }
      {project.projectTypes.fabrication && project.fabricationOptions?.bulkhead && 
        getFabricationType('Bulk Head')
      }
    </div>
  )
}; 